<template>
  <div class='homePage' id='homePage' ref='homePage'>
    <div class="mobile" v-show="isMobile">
      <div class='img-wrapper'>
        <div class="extractText"><span>Find the latest PGEBet official website, APK download, backup links and official support in one place.</span>
        </div>
        <img v-if="$store.state.locale==='EN'" :src='topImg' alt=""/>
        <img v-else :src='topImg2' alt=""/>
        <div class="locale">
          <span v-for="(item,index) in countryList" :key="index"
                :class="$store.state.locale===item.Language?'active':''"
                @click="chooseLocale(item)">{{ item.CountryNameLocal }}</span>
        </div>
      </div>
      <div class="apkStore" v-if="!isApk">
        <div class="titleBox"><img :src="robot"/>{{ $t('lang.signal.apk') }}</div>
        <div class="getExtra">{{ $t('lang.signal.extra1') }}<span style="color: #FFF27D">{{
            $t('lang.account.currencyType') + 19
          }}</span> {{ $t('lang.signal.extra2') }}
        </div>
        <div class="downLoad" @click="download">{{ $t('lang.common.downLoad') }}</div>
      </div>
      <div class='link'>{{ $t('lang.signal.link') }}</div>
      <div class='signals'>
        <div class='sign-item' v-for='(item,index) in signals' :key='index'>
          <div v-if="index===2" class="gradient-tp"/>
          <div v-if="index===0" class="gradient-bt"/>
          <div class="label">{{ item.DomainName }}</div>
          <div class="signal">
            <img :src="sign" v-if="item.DnsStatus===true"/>
            <img :src="noSign" v-else/>
          </div>
          <div class="btn" @click="gotoLink(item.DomainName)">{{$t('lang.signal.visit')}}</div>
        </div>
      </div>
      <div class="followUs"><img :src="add"/>{{ $t('lang.signal.follow') }}</div>
      <div class="socialDiv">
        <img :src="whatsapp" @click="goSocial(0)"/>
        <img :src="facebook" @click="goSocial(1)"/>
        <img :src="telegram" @click="goSocial(2)"/>
      </div>
      <div class="aboutTitle">
        <img :src="exclamation"/>{{ $t('lang.signal.about') }}
      </div>
      <div class="aboutDesc">
        {{ $t('lang.signal.aboutDesc') }}
      </div>
      <div class="faqTitle">
        <img :src="question"/>{{ $t('lang.signal.faq') }}
      </div>
      <div class="faqDesc">
        <div class="faqRow" v-for="(item,index) in $t('lang.signal.faqDesc')" :key="index">
          <div class="q">{{item.question}}</div>
          <div class="a">{{item.answer}}</div>
        </div>
      </div>
      <div class="signature">{{ $t('lang.signal.last') }}<br>13 July 2026</div>
      <div class="permit"><img :src="permit"/></div>
      <div class="live" @click="handelOpenChat"><img :src="live"/></div>
    </div>
    <div class="web" v-show="!isMobile">
      <div class="img-wrapper">
        <img class="webBack" :src='webBack'/>
        <div class="left-bar">
          <div class="row1">
            <img :src="robot2" class="robot2"/>
            <span>{{$t('lang.signal.apk')}}</span>
          </div>
          <div class="row2">
            {{ $t('lang.signal.extra1') }}<span style="color: #FFF27D">{{
              $t('lang.account.currencyType') + 19
            }}</span> {{ $t('lang.signal.extra2') }}
          </div>
          <div class="row3">
            <div class="downLoad2" @click="download">{{ $t('lang.common.downLoad') }}</div>
            <div class="qrcode" ref="qrcode">
              <qrcode-vue
                :size="qrSize"
                :value="downUrl"
                :className="'qrDiv'"
                background="#ffffff"
              >
              </qrcode-vue>
            </div>
          </div>
        </div>
        <div class="locale">
          <span v-for="(item,index) in countryList" :key="index"
                :class="$store.state.locale===item.Language?'active':''"
                @click="chooseLocale(item)">{{ item.CountryNameLocal }}</span>
        </div>
      </div>
      <div class='link'>{{ $t('lang.signal.link') }}</div>
      <div class='signals'>
        <div class='sign-item' v-for='(item,index) in signals' :key='index'>
          <div v-if="index===2" class="gradient-tp"/>
          <div v-if="index===0" class="gradient-bt"/>
          <div class="label">{{item.DomainName}}</div>
          <div class="signal">
            <img :src="sign" v-if="item.DnsStatus===true"/>
            <img :src="noSign" v-else/>
          </div>
          <div class="btn" @click="gotoLink(item.DomainName)">{{$t('lang.signal.visit')}}</div>
        </div>
      </div>
      <div class="followDiv">
        <div class="background"/>
        <div class="followUs">{{ $t('lang.signal.follow') }}</div>
        <div class="socialDiv">
          <img :src="w" @click="goSocial(0)"/>
          <img :src="f" @click="goSocial(1)"/>
          <img :src="t" @click="goSocial(2)"/>
        </div>
      </div>
      <div class="webPermit"><img :src="webPermit"/></div>
      <div class="live" @click="handelOpenChat"><img :src="live"/></div>
    </div>
  </div>
</template>

<script>
import webBack from '@/assets/images/common/webBack.png'
import question from '@/assets/images/common/question.svg'
import exclamation from '@/assets/images/common/exclamation.svg'
import topImg from '@/assets/images/common/top.webp'
import topImg2 from '@/assets/images/common/top2.webp'
import sign from '@/assets/images/common/sign.svg'
import noSign from '@/assets/images/common/noSign.svg'
import permit from '@/assets/images/common/permit.svg'
import webPermit from '@/assets/images/common/webPermit.png'
import robot from '@/assets/images/common/robot.svg'
import robot2 from '@/assets/images/common/robot2.svg'
import add from '@/assets/images/common/add.svg'
import live from '@/assets/images/common/live.svg'
import facebook from '@/assets/images/common/facebook.svg'
import telegram from '@/assets/images/common/telegram.svg'
import whatsapp from '@/assets/images/common/whatsapp.svg'
import w from '@/assets/images/common/w.svg'
import f from '@/assets/images/common/f.svg'
import t from '@/assets/images/common/t.svg'
import {mapMutations} from 'vuex'
import {Storage, LogUtils} from '@/utils'
import QrcodeVue from 'qrcode.vue'
import request from '@/service'

export default {
  name: 'Home',
  components: {
    QrcodeVue
  },
  data () {
    return {
      add,
      sign,
      live,
      permit,
      webPermit,
      noSign,
      facebook,
      telegram,
      whatsapp,
      w,
      f,
      t,
      robot,
      robot2,
      topImg,
      topImg2,
      question,
      exclamation,
      webBack,
      isApk: true,
      isMobile: false,
      countryList: [
        {
          'Id': 1,
          'CountryCode': 'IN',
          'CountryNameEn': 'English',
          'CountryNameLocal': 'EN',
          'Language': 'EN',
          'Active': true,
          'CreateTime': '2021-08-07T08:52:14.86'
        },
        {
          'Id': 2,
          'CountryCode': 'IN',
          'CountryNameEn': 'India',
          'CountryNameLocal': 'भारत',
          'Language': 'IN',
          'Active': true,
          'CreateTime': '2021-08-07T09:24:54.067'
        }
      ],
      qrSize: 30,
      downUrl: '',
      signals: [],
      urls: [
        'https://www.whatsapp.com/channel/0029VaMerIl8vd1K7xvJWl15',
        'https://www.facebook.com/PGEbet/',
        'https://t.me/PGEbet555'
      ]
    }
  },
  watch: {
  },
  async mounted () {
    const visitorCode = await LogUtils.getVisitorCode()
    LogUtils.saveUserEventParams('NavigationLoading', visitorCode, null, visitorCode, null)
    this.visitNav()
    this.getData()
    this.fetchVisitMachine()
    window.addEventListener('resize', this.fetchVisitMachine)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.fetchVisitMachine)
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    handelOpenChat () {
      window.LiveChatWidget.call('maximize')
    },
    visitNav: function () {
    },
    getData () {
      request('get', '/innovation/get/portal/domain/list?pageNo=1&pageSize=3')
        .then(res => {
          this.signals = res.result.records
          this.getDownUrl()
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchVisitMachine () {
      this.isApk = !!window.Android
      this.qrSize = window.innerWidth * 0.06
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    chooseLocale (internation) {
      this.showCountryDDL = !this.showCountryDDL
      this.setInternation(internation.CountryCode)
      // 2021-10-31 CHP 增加设置国家版本名字、语言
      this.setInternationName(internation.CountryNameLocal)
      localStorage.setItem('locale', internation.Language)
      localStorage.setItem('internationName', internation.CountryNameLocal)
      this.locale = internation.Language
      this.internationName = internation.CountryNameLocal
      this.$i18n.locale = internation.Language // localStorage.getItem('locale') // todo 切换版本
      this.$store.commit('setLocale', internation.Language)
      Storage.setExpire('locale', internation.Language, 7 * 24 * 3600)
    },
    download () {
      window.location.href = this.downUrl
    },
    getDownUrl () {
      const signal = this.signals.find(item => item.DnsStatus === true)
      if (signal && signal.DomainName) {
        let base = 'https://api.' + signal.DomainName
        this.downUrl = base + '/mobileapp/pge-' + signal.Channel + '-' + signal.Version + '.apk'
      }
    },
    gotoLink (link) {
      const end = window.location.search ? window.location.search : ''
      if (this.isMobile) {
        window.location.href = 'https://app.' + link + end
      } else {
        window.location.href = 'https://www.' + link + end
      }
    },
    goSocial (index) {
      window.open(this.urls[index])
    }
  }
}
</script>

<style lang='less' scoped>
.homePage {
  height: 100vh;
  overflow: scroll;
  position: relative;
  overflow-x: hidden;
  padding-bottom: 5vw;
  background: #130C09;

  .mobile {
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    height: max-content;

    .img-wrapper {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 100vw;
      height: 50vw;
      overflow: hidden;

      .extractText {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        color: rgba(0,0,0,0);
        display: flex;
        align-items: flex-end;
        padding-bottom: 3.5vw;
        font-size: 4vw;
      }
      img{
        width: 100%;
        height: auto;
      }
      .locale {
        position: absolute;
        top: 6.667vw;
        left: 6.11vw;
        width: 24.722vw;
        height: 7.5vw;
        border-radius: 2.222vw;
        border: 0.326vw solid #E2C28F;
        background: #1C0F0B;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        font-size: 4.166vw;
        font-weight: 400;
        text-align: center;
      }
      img {
        width: 100%;
      }
    }

    .apkStore {
      position: relative;
      top: 0;
      left: 50%;
      transform: translate(-50%);
      width: 92.222vw;
      height: 46.944vw;
      border-radius: 2.222vw;
      box-shadow: 0 0 4.8px 0 rgba(0, 0, 0, 0.08);
      border: 0.277vw solid #E3C491;
      .titleBox{
        width: 100%;
        height: 13.888vw;
        text-align: center;
        color: #F6D9AA;
        font-size: 5.277vw;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 0.277vw solid #E3C491;
        padding-bottom: 1vw;

        img {
          height: 5.277vw;
          margin-right: 2vw;
          margin-bottom: 0.5vw;
        }
      }

      .getExtra {
        margin: 6vw 0 4vw 0;
        text-align: center;
        font-size: 5vw;
        height: 5vw;
        line-height: 5vw;
        font-weight: 700;
        letter-spacing: -0.01em;
        color: #D9D9D9;
      }

      .downLoad {
        margin: 0 auto;
        width: 77.65vw;
        height: 11.388vw;
        line-height: 11.388vw;
        border-radius: 2.222vw;
        text-align: center;
        color: #000000;
        font-size: 5.833vw;
        font-weight: 700;
        background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
        linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        text-shadow: 0px -0.5px 0.5px rgba(0, 0, 0, 0.46);
        animation: zoom 300ms ease-in-out infinite alternate;
      }

      @keyframes zoom {
        0% {
          transform: scale(0.8);
        }
        100% {
          transform: scale(1); /* 放大倍数可根据需要调整 */
        }
      }

    }

    .link {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 100vw;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      line-height: 23px;
      color: #F6D9AA;
      margin: 3vw 0;
    }

    .signals {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      text-align: center;
      width: 92.222vw;
      height: 40vw;
      border-radius: 2.222vw;
      border: 1px solid #E3C491;
      .sign-item {
        position: relative;
        padding-left: calc(30vw / 3.6);
        padding-right: calc(23vw / 3.6);
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        height: 33.333%;
        padding-bottom: 3vw;

        .label {
          width: calc(93vw / 3.6);
          overflow: visible;
          font-size: 5vw;
          font-weight: 700;
          text-align: left;
          color: #FFFFFF;
          overflow: visible;
        }

        .signal {
          margin-left: 8.5vw;

          img {
            width: 5vw;
          }
        }

        .btn {
          background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
          width: 102px;
          height: 7.777vw;
          line-height: 7.777vw;
          border-radius: 3px;
          text-align: center;
          color: #0C0C0C;
          font-size: 4.444vw;
          font-weight: 700;
          letter-spacing: -0.01em;
          cursor: pointer;
        }

        .gradient-tp {
          position: absolute;
          top: -0.5vw;
          left: 50%;
          transform: translate(-50%);
          width: 100%;
          height: 0.3vw;
          opacity: 0.2;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) -3.36%, #FFFFFF 54%, rgba(255, 255, 255, 0) 100.94%);
        }

        .gradient-bt {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%);
          width: 100%;
          height: 0.3vw;
          opacity: 0.2;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) -3.36%, #FFFFFF 54%, rgba(255, 255, 255, 0) 100.94%);
        }
      }

    }

    .followUs {
      position: relative;
      top: 4vw;
      left: 50%;
      transform: translate(-50%);
      width: 91vw;
      height: 6.112vw;
      color: #F6D9AA;
      font-size: 5.277vw;
      font-weight: 700;
      text-align: left;

      img {
        margin-right: 2.5vw;
        width: 4.444vw;
      }
    }

    .aboutTitle {
      position: relative;
      margin-top: calc(18vw / 3.6);
      left: 50%;
      transform: translate(-50%);
      width: 91vw;
      height: 6.112vw;
      color: #F6D9AA;
      font-size: 5.277vw;
      font-weight: 700;
      text-align: left;

      img {
        margin-right: 2.5vw;
        width: 4.444vw;
      }
    }

    .aboutDesc {
      position: relative;
      top: 0;
      margin-top: calc(18vw / 3.6);
      left: 50%;
      transform: translate(-50%);
      width: 91vw;
      text-align: left;
      font-family: 'Inter';
      font-weight: 400;
      font-size: calc(14vw / 3.6);
      line-height: calc(17vw / 3.6);
      color: #FCFCFC;
    }

    .faqTitle {
      position: relative;
      margin-top: 5vw;
      left: 50%;
      transform: translate(-50%);
      width: 91vw;
      height: 6.112vw;
      color: #F6D9AA;
      font-size: 5.277vw;
      font-weight: 700;
      text-align: left;

      img {
        margin-right: 2.5vw;
        width: 4.444vw;
      }
    }

    .faqDesc {
      position: relative;
      margin-top: calc(18vw / 3.6);
      left: 50%;
      transform: translate(-50%);
      width: 91vw;
      text-align: left;
      font-family: 'Inter';
      font-weight: 400;
      font-size: calc(14vw / 3.6);
      line-height: calc(17vw / 3.6);
      color: #FCFCFC;

      .faqRow {
        margin: calc(16vw / 3.6) auto;

        .q {
          font-weight: 700;
          margin-bottom: 0.5vw;
        }
      }
    }

    .signature {
      position: relative;
      margin-top: calc(18vw / 3.6);
      left: 50%;
      transform: translate(-50%);
      width: 91vw;
      text-align: left;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: calc(14vw / 3.6);
      line-height: calc(17vw / 3.6);
      color: #D9D9D9;
    }

    .socialDiv {
      position: relative;
      margin-top: 8vw;
      left: 50%;
      transform: translate(-50%);
      width: 77.22vw;
      height: 22.777vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .permit {
      position: relative;
      top: 15vw;
      left: 50%;
      transform: translate(-50%);
      width: 38.694vw;
      height: 8.333vw;
      margin-bottom: 18vw;
      img{
        width: 100%;
      }
    }

    .live {
      position: fixed;
      top: 73 dvh;
      right: 0;
      height: 13.611vw;
      img{
        width: 100%;
      }
    }
  }

  .web {
    position: relative;
    top: 0;
    width: 100%;
    height: max-content;
    .img-wrapper {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      height: 43.57vw;
      overflow: hidden;

      .webBack {
        width: 100%;
      }

      .left-bar {
        position: absolute;
        top: 17vw;
        left: 7.292vw;

        .row1 {
          margin-left: -1.8vw;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .robot2 {
            height: 6vw;
            margin-right: 0.3vw;
          }

          span {
            background: linear-gradient(90.29deg, #FDD089 -19.95%, #FFFFFF 116.46%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-size: 3.125vw;
            font-weight: 700;
            text-align: left;
          }
        }

        .row2 {
          margin-top: 0.5vw;
          font-size: 2.239vw;
          height: 2.239vw;;
          font-weight: 700;
          text-align: left;
          color: #EFEFEF;
        }

        .row3 {
          margin-top: 1.3vw;
          width: 31.726vw;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .downLoad2 {
            width: 22.656vw;
            height: 4.635vw;
            line-height: 4.635vw;
            text-align: center;
            border-radius: 0.416vw;
            color: #000000;
            font-size: 2.187vw;
            font-weight: 700;
            background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
            linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
            text-shadow: 0px -0.5px 0.5px rgba(0, 0, 0, 0.46);
            cursor: pointer;
            //animation: zoom 300ms ease-in-out infinite alternate;
          }

          .qrcode {
            width: 7.351vw;
            height: 7.351vw;
            background: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            .qrDiv{
              padding: 0;
              width: 6vw;
              height: 6vw;
            }
          }
        }
      }
      .locale {
        position: absolute;
        top: 4.230vw;
        left: 81.541vw;
        width: 13.281vw;
        height: 3.594vw;
        border-radius: 2.552vw;
        background: rgba(0, 0, 0, 0.47);
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        font-size: 2.031vw;
        font-weight: 400;
        text-align: center;

        span {
          cursor: pointer;
        }
      }
    }

    .link {
      position: relative;
      margin-top: -4vw;
      width: 100%;
      height: 3.593vw;
      text-align: center;
      color: #F6D9AA;
      font-size: 3.593vw;
      font-weight: 700;
      z-index: 5;
    }

    .signals {
      position: relative;
      left: 50%;
      top: 2vw;
      transform: translate(-50%);
      width: 87.734vw;
      height: 19.27vw;
      border: 0.1vw solid #E3C491;
      border-radius: 1.04vw;
      .sign-item {
        position: relative;
        padding-left: 2.083vw;
        padding-right: 2.083vw;
        padding-bottom: 1.5vw;
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        height: 33.333%;

        .label {
          width: 16vw;
          font-size: 2.395vw;
          font-weight: 700;
          text-align: left;
          color: #FFFFFF;
          overflow: visible;
        }

        .signal {
          margin-left: 36vw;

          img {
            height: 2.760vw;
          }
        }

        .btn {
          background: linear-gradient(270.12deg, #DEBC86 -2.41%, #F7DEB8 113.36%);
          width: 21.041vw;
          height: 3.593vw;
          line-height: 3.593vw;
          border-radius: 0.156vw;
          text-align: center;
          color: #0C0C0C;
          font-size: 1.875vw;
          font-weight: 700;
          letter-spacing: -0.01em;
          cursor: pointer;
        }

        .gradient-tp {
          position: absolute;
          top: -0.25vw;
          left: 50%;
          transform: translate(-50%);
          width: 100%;
          height: 0.156vw;
          opacity: 0.2;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) -3.36%, #FFFFFF 54%, rgba(255, 255, 255, 0) 100.94%);
        }

        .gradient-bt {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%);
          width: 100%;
          height: 0.156vw;
          opacity: 0.2;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) -3.36%, #FFFFFF 54%, rgba(255, 255, 255, 0) 100.94%);
        }
      }
    }

    .followDiv {
      position: relative;
      top: 6vw;
      width: 100vw;
      height: 6.666vw;
      overflow: hidden;
      border-right: none;
      border-left: none;
      border: 0.07vw solid;
      border-image: linear-gradient(90.34deg, rgba(255, 255, 255, 0) 3.17%, #8D8270 70.24%, #D9C097 100.2%) 30;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 6vw;
      padding-right: 9.7vw;

      .background {
        position: absolute;
        top: -2vw;
        left:21vw;
        width: 106.25vw;
        height: 25.364vw;
        background: radial-gradient(50% 50% at 50% 50%, #532800 0%, rgba(134, 0, 0, 0.4) 50%, rgba(185, 0, 0, 0) 100%);
        opacity: 48%;
      }

      .followUs {
        font-size: 2.5vw;
        font-weight: 700;
        text-align: left;
        color: #F6D9AA;
      }

      .socialDiv {
        display: flex;
        width: 18.281vw;
        justify-content: space-between;
        align-items: center;
        z-index: 5;

        img {
          width: 4.01vw;
          height: 4.01vw;
          cursor: pointer;
        }
      }
    }

    .webPermit {
      position: relative;
      top: 9vw;
      margin-bottom: 5vw;
      width: 100%;
      height: max-content;
      display: flex;
      justify-content: center;

      img {
        height: 4.843vw;
      }
    }
    .live {
      position: fixed;
      top: 32.661vw;
      right: 10px;
      height: 5.729vw;
      cursor: pointer;
      z-index: 10;

      img {
        height: 100%;
      }
    }

  }

  .active {
    color: #B8B0B0;
    font-weight: 700;
  }

}

@media screen and (min-width: 750px) {
  .homePage::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #000000;
  }

  ::-webkit-scrollbar-thumb {
    background: #666666;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue